import { render, staticRenderFns } from "./TabRepresentante.vue?vue&type=template&id=f584c812&"
import script from "./TabRepresentante.vue?vue&type=script&lang=js&"
export * from "./TabRepresentante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports